import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useDownloadRecibo = () => {
  return useMutation({
    mutationFn: ({
      uuidAgendamento,
      uuidFatura,
    }: {
      uuidAgendamento: string;
      uuidFatura: string;
    }) => Agendamento.downloadRecibo({ uuidAgendamento, uuidFatura }),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
